import { render, staticRenderFns } from "./RingbaPhoneNumberDialog.vue?vue&type=template&id=a6f1dcd4&scoped=true&"
import script from "./RingbaPhoneNumberDialog.vue?vue&type=script&lang=js&"
export * from "./RingbaPhoneNumberDialog.vue?vue&type=script&lang=js&"
import style0 from "./RingbaPhoneNumberDialog.vue?vue&type=style&index=0&id=a6f1dcd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f1dcd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
